<template>
  <el-dialog
    title="商品导入失败原因"
    width="50%"
    :visible.sync="dialogVisible"
   >
    <div class="wrap">
      <el-table :data="failedList">
        <!--  prop="image" -->
        <el-table-column
          label="图片"
          >
          <template slot-scope="{row}">
             <div style="display: flex; align-items: center">
              <ListLazyImg :src="`${row.image}`" />
            </div>
          </template>
      </el-table-column>
      <el-table-column
          prop="outerId"
          label="款式编码"
          >
      </el-table-column>
      <el-table-column
          prop="title"
          label="商品名"
          >
      </el-table-column>
      <el-table-column
          prop="msg"
          label="失败原因"
          >
      </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import ListLazyImg from '@/components/ListLazyImg/index.vue'
export default {
  data() {
    return {
      failedList:[],
      dialogVisible: false
    }
  },
  components: {
    ListLazyImg
  },
  methods: {
    method_open(list) {
      this.failedList = list;
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>